import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { GRAY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { useTireFilterStore } from 'context/SelectionStore/Manager/TireFilterStoreContext'
import { TireService } from 'lib/api/services/TireService'

const useStyles = makeStyles(() => ({
  header: { display: 'flex', alignItems: 'center', marginBottom: 20 },
  heading: { fontSize: 16, fontWeight: 600, marginRight: 'auto' },
  container: { display: 'flex', flexDirection: 'column', gap: 16 },
  row: { display: 'flex', flexDirection: 'row', gap: 16 },
  rangeInputLeft: { borderTopRightRadius: 0, borderBottomRightRadius: 0 },
  rangeInputRight: { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
}))

const TireFilterDialog = ({ setIsFilterFullOpen }) => {
  const classes = useStyles()
  const [brands, setBrands] = useState([])
  const [loading, setLoading] = useState(false)
  const {
    store: { filter },
    func: { onChangeFilter, onSearch, onResetFilter }
  } = useTireFilterStore()

  useEffect(() => {
    const fetchMarks = async () => {
      const res = await TireService.getMarks()
      setBrands(res.data || [])
    }
    fetchMarks()
  }, [])

  const handleClose = () => setIsFilterFullOpen(false)

  const onChange = e => {
    const { name, value } = e.target
    if (name === 'studs' && value) {
      onChangeFilter({ studs: value, season: 'Зима шипы' })
      return
    }
    onChangeFilter({ [name]: value })
  }

  const onReset = () => {
    onResetFilter()
    handleClose()
  }

  const onSave = async () => {
    setLoading(true)
    await onSearch()
    handleClose()
    setLoading(false)
  }

  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{ color: GRAY_COLORS[400], padding: 0, marginRight: 8 }}
            onClick={handleClose}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Фильтр шин</div>
        </div>
      }
    >
      <div className={classes.container}>
        <div className={classes.row}>
          <TextField
            label="Диаметр от"
            value={filter?.radiusFrom}
            name="radiusFrom"
            onChange={onChange}
            className={classes.rangeInputLeft}
          />
          <TextField
            label="Диаметр до"
            value={filter?.radiusTo}
            name="radiusTo"
            onChange={onChange}
            className={classes.rangeInputRight}
          />
        </div>

        <div className={classes.row}>
          <TextField
            label="Высота от"
            value={filter?.heightFrom}
            name="heightFrom"
            onChange={onChange}
            className={classes.rangeInputLeft}
          />
          <TextField
            label="Высота до"
            value={filter?.heightTo}
            name="heightTo"
            onChange={onChange}
            className={classes.rangeInputRight}
          />
        </div>

        <div className={classes.row}>
          <TextField
            label="Ширина от"
            value={filter?.widthFrom}
            name="widthFrom"
            onChange={onChange}
            className={classes.rangeInputLeft}
          />
          <TextField
            label="Ширина до"
            value={filter?.widthTo}
            name="widthTo"
            onChange={onChange}
            className={classes.rangeInputRight}
          />
        </div>

        <FormControl fullWidth>
          <InputLabel>Сезонность</InputLabel>
          <Select
            value={filter?.season || ''}
            name="season"
            onChange={onChange}
          >
            <MenuItem value="Всесезонная">Всесезонная</MenuItem>
            <MenuItem value="Зима шипы">Зима шипы</MenuItem>
            <MenuItem value="Лето">Лето</MenuItem>
            <MenuItem value="Зима липучка">Зима липучка</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Шипы</InputLabel>
          <Select value={filter?.studs || ''} name="studs" onChange={onChange}>
            <MenuItem value={null}>Нет</MenuItem>
            <MenuItem value="Зима шипы">Да</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Бренд</InputLabel>
          <Select value={filter?.mark || ''} name="mark" onChange={onChange}>
            {brands.map(b => (
              <MenuItem key={b.id} value={b.id}>
                {b.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Диски</InputLabel>
          <Select value={filter?.hasRims} name="hasRims" onChange={onChange}>
            <MenuItem value={true}>Есть</MenuItem>
            <MenuItem value={false}>Нет</MenuItem>
          </Select>
        </FormControl>

        <div className={classes.row} style={{ gap: 16 }}>
          <Button fullWidth onClick={onReset} disabled={loading}>
            Сбросить
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={onSave}
            disabled={loading}
          >
            Применить
          </Button>
        </div>
      </div>
    </PageContainerMobile>
  )
}

export default TireFilterDialog
